import script from "./ModalProcessProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalProcessProgress.vue?vue&type=script&setup=true&lang=ts"

import "./ModalProcessProgress.vue?vue&type=style&index=0&id=11394cda&lang=scss"

const __exports__ = script;

export default __exports__